/**
 * État de chargement du widget météo : 2 blocs animés (header + zone graphique).
 * Sert aussi de placeholder avant que React Query ait reçu la 1ère réponse.
 */

export function MeteoSkeleton() {
  return (
    <div className="space-y-3" aria-busy="true" aria-label="Chargement des prévisions météo">
      <div className="h-[60px] w-full animate-pulse rounded-md bg-champagne-100" />
      <div className="h-[170px] w-full animate-pulse rounded-md bg-champagne-100" />
    </div>
  );
}
